import { IAccountSideBar } from '~exported/account-sidebar/AccountSidebar';
import AccountSidebarController from '~exported/account-sidebar/AccountSidebarController';
import { loadOnDemand } from '~utils/loadOnDemand';

import * as features from './features';
import { sidebarSections } from './sections';

export interface ISidebarFeature {
    controller: AccountSidebarController;
    componentConfig?: IAccountSideBar['config']['accountSidebarConfig'];
    children?: JSX.Element | JSX.Element[];
}

export const getSidebarViewRegistry = (featureConfig: ISidebarFeature) => {
    const { componentConfig = {}, controller } = featureConfig;

    return {
        [sidebarSections.loyalty]: loadOnDemand(features.Loyalty, {
            rewardsLink: componentConfig?.[sidebarSections.loyalty]?.params?.rewardsLink
        }),
        [sidebarSections.menu]: loadOnDemand(features.Menu, {
            menu: componentConfig?.[sidebarSections.menu]?.params?.menu || [],
            onClick: controller.handleMenuLinkOnClick
        }),
        [sidebarSections.showcase]: loadOnDemand(features.Showcase, {
            brandServices: componentConfig?.[sidebarSections.showcase]?.params?.brandServices,
            onClick: controller.handleShowcaseOnClick
        }),
        [sidebarSections.welcome]: loadOnDemand(features.Welcome, {
            hideOverlay: controller.hideOverlay,
            welcomeBack: componentConfig?.[sidebarSections.welcome]?.params?.welcomeBack,
            isOverlayVisible: controller.data.isOverlayVisible
        })
    };
};
